<div class="score-sheet-list">
  <header class="score-sheet-list__header">
    <h1>Scoresheets</h1>
    <p class="score-sheet-list__subtitle">Licensed games for the selected date.</p>
  </header>

  <form class="score-sheet-list__filters" (submit)="$event.preventDefault()">
    <mat-form-field class="score-sheet-list__filter score-sheet-list__filter--date" appearance="fill">
      <mat-label>Date</mat-label>
      <input matInput [matDatepicker]="picker" [(ngModel)]="selectedDate" name="date"
             (dateChange)="onDateChange($event.value)">
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
    <mat-form-field class="score-sheet-list__filter score-sheet-list__filter--league" appearance="fill">
      <mat-label>Licenced league</mat-label>
      <mat-select [(ngModel)]="selectedLeagueId" name="league" (selectionChange)="onLeagueChange()">
        <mat-option value="">All leagues</mat-option>
        <mat-optgroup *ngFor="let group of leagueGroups$ | async" [label]="group.federation">
          <mat-option *ngFor="let league of group.leagues" [value]="league.id">
            {{ league.name }}
          </mat-option>
        </mat-optgroup>
      </mat-select>
    </mat-form-field>
  </form>

  <ng-container *ngIf="groups$ | async as groups">
    <ng-container *ngIf="!loading; else loadingTpl">
      <div *ngIf="!groups.length" class="score-sheet-list__empty">
        No licensed games for the selected date.
      </div>

      <section *ngFor="let group of groups" class="score-sheet-list__league">
        <header class="score-sheet-list__league-header">
          <img *ngIf="group.league?.smallLogoUrl" [src]="group.league.smallLogoUrl" alt="" class="score-sheet-list__league-logo">
          <h2>{{ group.leagueName }}</h2>
        </header>

        <ul class="score-sheet-list__games">
          <li *ngFor="let row of group.rows" class="score-sheet-list__game"
              [class.score-sheet-list__game--live]="row.status === 'live'"
              [class.score-sheet-list__game--final]="row.status === 'final'"
              [class.score-sheet-list__game--scheduled]="row.status === 'scheduled'"
              [class.score-sheet-list__game--no-data]="row.status === 'noData'">
            <span class="score-sheet-list__time">
              {{ row.scheduled?.toDate() | date: 'HH:mm' }}
            </span>
            <span class="score-sheet-list__status">{{ statusLabel(row.status) }}</span>
            <span class="score-sheet-list__matchup">
              <span class="score-sheet-list__team">{{ row.awayName }}</span>
              <span *ngIf="row.hasData; else vsTpl" class="score-sheet-list__score">
                {{ row.awayRuns ?? 0 }} – {{ row.homeRuns ?? 0 }}
              </span>
              <ng-template #vsTpl>
                <span class="score-sheet-list__vs">vs</span>
              </ng-template>
              <span class="score-sheet-list__team">{{ row.homeName }}</span>
            </span>
            <a *ngIf="row.hasData; else noLinkTpl"
               class="score-sheet-list__open"
               [routerLink]="['/score-sheet', 'game', row.gameId]">
              Open scoresheet
            </a>
            <ng-template #noLinkTpl>
              <span class="score-sheet-list__open score-sheet-list__open--disabled">No scoresheet</span>
            </ng-template>
          </li>
        </ul>
      </section>
    </ng-container>
  </ng-container>

  <ng-template #loadingTpl>
    <div class="score-sheet-list__empty">Loading…</div>
  </ng-template>
</div>
